export const environment = {
  production: true,
  apiUrl: 'https://#{DOMAIN_NAME}#/api',
  microApps: 'https://#{DOMAIN_NAME}#/assets/microapp-prod.json',
  mainPath: 'main',
  httpEncrypt: true,
  timeSession: 300,
  jwtService: {
    url: 'https://micuenta.pichincha.com/onb-gtw-transactional/api/v1/onb-msa-security/removeSession',
  },
  http: {
    encrypt: true,
    publicKey:
      '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1XKa1dTnlLemi/4gTYL7s5m5M7psYvbsD63Nr35isGgsJ9Eh/O7Pz31OYe6xdmPli+D0kWxjDIlDzOC5QD2+lqjfzUzzZi13+R/LvOnU9jtqTfiFmrHq9KcDGJjGn8dEBiIabtlZkJVn0f9LyvRE78Qd5rnhEt0J1nHgb6hec8EOfMy9OkPSleI/qhspNxGWuTYBts4aonWN5RnujI/fUt7tWSHuswQnBjhg80UK991RosjiE8c1T60pYugLqkeaU/twMlL0mb4em8CCLMqIYPaavqlMsl8gJz6yODvMf39m4LVtysg/osgdN6T/zW2HM6ERtsjI8uQH9x5BLMoKlwIDAQAB-----END PUBLIC KEY-----',
    ivKey: 'JexS3UEqjvsPpIQi',
    symKey: 'HBbbny5ZVHXAoBCS',
  },
  authProvider: {
    clientId: '#{FRONTEND_B2C_CLIENTID}#',
    tenantName: '#{FRONTEND_B2C_DOMAIN}#',
    tenantId: '#{FRONTEND_B2C_TENANTID}#',
    redirectUrl: '#{FRONTEND_B2C_REDIRECTURL}#',
    autority: '#{FRONTEND_B2C_AUTORITY}#',
    scopes: ['#{FRONTEND_B2C_SCOPES}#'],
    accessTokenName: 'access_token',
    authToken: 'auth_token',
    Apikey: '#{APIM_SUBSCRIPTION_KEY_BUSINESS_BANKING}#',
  },
  storage: {
    key: 'MTl2paP59',
  },
  google: {
    tagManagerId: '#{GOOGLE_TAG_MANAGER_ID}#',
    captchaSiteKey: '6LdFYCQkAAAAAHzcU3Hk3PgDtt6KBPp3IKIpsw7b',
    analyticsId: 'G-15HGVQBYTH',
    mapsKey: 'AIzaSyB1tkqAP4G3nUfrXyjONApHUJnNVSUZ4Js',
  },
  translationFiles: 'https://#{DOMAIN_NAME}#/assets/locales/',
  hotJar: '#{HOTJAR_SITE_ID}#',
}
